const setGateway = gateway => ({ gateway });
const setAccountRecommendationsAddress = accountRecommendations => ({ accountRecommendations });
const setDomain = domain => ({ domain });
const setMainPage = mainPage => ({ mainPage });
const setProduction = environment => ({
  production: environment !== 'development'
});
const setFacebookAuthenticationDomain = facebookAuthenticationDomain => ({ facebookAuthenticationDomain });
const setProjectVersion = version => ({ version });


export default {
  ...setGateway(process.env.GATEWAY),
  ...setMainPage(process.env.MAIN_PAGE),
  ...setProduction(process.env.NODE_ENV),
  ...setFacebookAuthenticationDomain(process.env.FACEBOOK_AUTHENTICATION_DOMAIN),
  ...setDomain(process.env.DOMAIN),
  ...setAccountRecommendationsAddress(process.env.ACCOUNT_RECOMMENDATIONS),
  ...setProjectVersion(process.env.VERSION)
};
